import { connect } from 'react-redux';
import {
  Name,
  Flex,
  CategoryHeaderRow,
  CongratsText
} from './styles'
import { useWindowSize } from '../../../../../../../hooks/useWindowSize';
import UnlockedCategoryMedal from '../../../../../../components/UnlockedCategoryMedal';

const CategoryHeader = ({
  category,
}) => {
  const { isMobile } = useWindowSize()

  return (
    <Flex style={{ flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
      <CategoryHeaderRow>
        <Flex style={{ flexDirection: isMobile ? 'column' : 'row', width: '100%' }}>
          <UnlockedCategoryMedal category={category} width={isMobile ? "62px" : "45px"} height="auto" />

          <Flex style={{ flexDirection: 'column', gap: 0, alignItems: 'flex-start' }}>
            <CongratsText>¡Desbloqueaste una nueva categoría! {!isMobile && <>🎉</>}</CongratsText>
            <div style={{ height: 8 }} />
            <Name>{category?.name}</Name>
          </Flex>
        </Flex>
      </CategoryHeaderRow>
    </Flex>
  )
}

const state = ({ groupStore }) => {
  const { data: group, states: groupStates } = groupStore.group;

  return {
    group,
    groupStates
  };
};

export default connect(state)(CategoryHeader);